import React from "react";

const StatCard = ({ icon: Icon, title, value, subtitle, color, alert }) => (
  <div
    className={`bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow ${
      alert ? "border-red-500 bg-red-50" : "border-gray-200"
    }`}
  >
    <div className="flex items-start justify-between mb-4">
      <div
        className="w-12 h-12 rounded-lg flex items-center justify-center"
        style={{ backgroundColor: alert ? "#fee2e2" : `${color}15` }}
      >
        <Icon size={24} style={{ color: alert ? "#dc2626" : color }} />
      </div>
    </div>
    <h3
      className={`text-sm font-medium mb-1 ${
        alert ? "text-red-600" : "text-gray-500"
      }`}
    >
      {title}
    </h3>
    <p
      className={`text-2xl font-bold mb-1 ${
        alert ? "text-red-900" : "text-gray-900"
      }`}
    >
      {value}
    </p>
    {subtitle && <p className="text-xs text-gray-400">{subtitle}</p>}
  </div>
);

export default StatCard;
